// extracted by mini-css-extract-plugin
export default {"cta":"styles_cta__bKziN","action":"styles_action__ml-NW","body":"styles_body__8CYK1","content":"styles_content__d9Oy+"};